window.addEventListener('load', () => {
    // console.log('load pagee');
    let revWidget = setInterval(()=>{
        if(document.querySelector('.jdgm-rev-widg__reviews') != null){
            adjustReviews();
            clearInterval(revWidget)
        }
    },50)

    setTimeout(() =>{
        clearInterval(revWidget)
    },15000)
});

function adjustReviews(){
    let rting =  document.querySelector('.jdgm-rev-widg').dataset.averageRating;
    let profiles = document.querySelectorAll('.jdgm-row-profile');
    let histoRatings = document.querySelectorAll('.jdgm-histogram .jdgm-histogram__row[data-frequency]');
    document.querySelector('.jdgm-rev-widg__title').innerHTML = 'Customer Stories';
    if(document.querySelector('.jdgm-rev-widg__summary .jdgm-rev-widg__summary-inner') != null){
        document.querySelector('.jdgm-rev-widg__summary .jdgm-rev-widg__summary-inner').insertAdjacentHTML('afterbegin',`<span class="avergae-rating">${rting}</span>`);
    }
    if(document.querySelector('.jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown-wrapper') != null){
        let saveEle = document.querySelector('.jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown-wrapper');
        let x = saveEle.parentElement.removeChild(saveEle);
        document.querySelector('.jdgm-widget-actions-wrapper').insertAdjacentElement('beforeend',x);
    }
    profiles.forEach((prf) =>{
        let content = prf.closest('.jdgm-rev').querySelector('.jdgm-rev__content .jdgm-rev__body');
        let p = prf.parentElement.removeChild(prf);
        content.insertAdjacentElement('afterend',p);
    })
    histoRatings.forEach((rt) =>{
        // console.log('rttt',rt);
        let freq = rt.querySelector('.jdgm-histogram__frequency');
        let r = freq.parentElement.removeChild(freq);
        r.innerHTML = rt.dataset.rating;
        rt.insertAdjacentElement('afterbegin',r);

    })

}